export const NotFound = () => <div>404</div>
